import { Form } from 'antd';
import classnames from 'classnames';
import styles from './LargeScreenFilters.module.scss';
import { FormFieldDropdown } from 'src/modules/form';
import React from 'react';
import { GenericFiltersProps } from 'src/modules/form/field/filters/types';

export const LargeScreenFilters = ({ form, filters, className }: GenericFiltersProps) => {
  return (
    <div className={classnames(styles.largeScreenFilters, className)}>
      {Object.entries(filters).map(([filterFormName, filter], i, { length }) => {
        return (
          <React.Fragment key={`LargeScreenFilter-${filterFormName}`}>
            <Form.Item
              shouldUpdate={() => true}
              name={filterFormName}
              className={styles.largeScreenFormItem}>
              <FormFieldDropdown
                onSave={() => form.submit()}
                labelKey={filter.labelKey}
                items={filter.items}
              />
            </Form.Item>
            {i < length - 1 && (
              <div
                key={`LargeScreenFilter-separator-${filterFormName}`}
                className={styles.verticalSeparator}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
